const { recordLink, recordLinkV2 }= require('utilities/tagging');
const { 
    LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    TAG_EVENT_OPEN,
    TAG_EVENT_CLOSE,
    CLICK_BUTTON_ACTION,
    CLICK_LINK_EVENT,
    TAG_DOWNLOAD,
    TAG_PRINT,
    TAG_PREVIOUS,
    CLICK_TEXT_BOX_EVENT,
    contractEasyLoan: { PAYMENT_DAY_OTHER }
}= require('../../../../loansConstants');

const CLICK_RADIO_BUTTON_EVENT = "clickRadioButton";

export const analyticsId = {
    CONTRACT_EASY_LOAN_STEP_1_VIEW: "CONTRACT_EASY_LOAN_STEP_1_VIEW",
    CONTRACT_EASY_LOAN_STEP_2_VIEW: "CONTRACT_EASY_LOAN_STEP_2_VIEW",
    CONTRACT_EASY_LOAN_STEP_1_SUCCESS: "CONTRACT_EASY_LOAN_STEP_1_SUCCESS",
    CONTRACT_EASY_LOAN_STEP_2_SUCCESS: "CONTRACT_EASY_LOAN_STEP_2_SUCCESS",
    CONTRACT_EASY_LOAN_WIZARD_ERROR: "CONTRACT_EASY_LOAN_WIZARD_ERROR",
    CONTRACT_EASY_LOAN_WIZARD_SUCCESS: "CONTRACT_EASY_LOAN_WIZARD_SUCCESS",
    CLICK_BREADCRUMB_01: "CLICK_BREADCRUMB_01",
    CONTRACT_EASY_LOAN_CONTRACT_BUTTON: "CONTRACT_EASY_LOAN_CONTRACT_BUTTON",
};

const commonFields = () => ({
    sectionFamily: "banking",
    sectionCategory: "products",
    sectionName: "loans",
    serviceType: "productContracting",
    interactionType: "funnel",
    processType: "loanContracting",
});

export const catalogue = {
    [analyticsId.CONTRACT_EASY_LOAN_STEP_1_VIEW]: () => ({
        ...commonFields(),
        event_name: "step_account_selection",
        pageName: "/loanContracting/step4/accountSelection",
        processStep: "step4",
        processDetail: "accountSelection",
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_2_VIEW]: ({ data }) => ({
        ...commonFields(),
        event_name: "step_confirmation",
        pageName: "/loanContracting/step5/confirmation",
        processStep: "step5",
        processDetail: "confirmation",
        pasoProceso: "step5",
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_1_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "accountSelection",
        data: true,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_2_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "confirmation",
        data: true,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_WIZARD_ERROR]: ({
        data,
        errorMessage,
    }) => ({
        ...commonFields(),
        event_name: "step_error",
        pageName: "/loanContracting/error/requestError",
        processStep: "error",
        processDetail: "requestError",
        errorCategory: "requestError",
        errorDescription: errorMessage,
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_WIZARD_SUCCESS]: ({ data }) => ({
        ...commonFields(),
        event_name: "step_success",
        pageName: "/loanContracting/success",
        processStep: "success",
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
        data: `${data}%`,
    }),
    [analyticsId.CLICK_BREADCRUMB_01]: () => ({
        categoriaEvento: window.utag_last_name,
        accionEvento: "préstamos e hipotecas",
        etiquetaEvento: "breadcrumb01",
    }),
    [analyticsId.CONTRACT_EASY_LOAN_CONTRACT_BUTTON]: () => ({
        data: true,
        eventCategory: CONTRACT_EASY_LOAN_CATEGORY_EVENT,
        eventName: CLICK_BUTTON_ACTION,
        eventTag: "contract",
    }),
};

export const recordEasyLoanCApprovedAccount = (tagEvent) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    "accountDropdown",
    tagEvent
);

export const recordEasyLoanCApprovedAccountOpen = () => recordEasyLoanCApprovedAccount(TAG_EVENT_OPEN);
export const recordEasyLoanCApprovedAccountClose = () => recordEasyLoanCApprovedAccount(TAG_EVENT_CLOSE);
export const recordEasyLoanCApprovedAccountSelection = () => recordEasyLoanCApprovedAccount('selection');

export const recordEasyLoanCApprovedDayElector = (value) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_RADIO_BUTTON_EVENT,
    value === PAYMENT_DAY_OTHER ? 'dia 4' : 'finde mes'
);

export const recordEasyLoanCApprovedWizardButton = (eventName) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_BUTTON_ACTION,
    eventName
);

export const recordEasyLoanCApprovedWizardNext = () => recordEasyLoanCApprovedWizardButton("next");
export const recordEasyLoanCApprovedWizardPrevious = () => recordEasyLoanCApprovedWizardButton(TAG_PREVIOUS);

export const recordEasyLoanCApprovedINEClick = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_LINK_EVENT,
    "ineLink"
);


export const recordEasyLoanCApprovedDocument = (tagEvent) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_LINK_EVENT,
    tagEvent
);

export const recordEasyLoanCApprovedDocumentDownload = () => recordEasyLoanCApprovedDocument(TAG_DOWNLOAD);
export const recordEasyLoanCApprovedDocumentPrint = () => recordEasyLoanCApprovedDocument(TAG_PRINT);

export const recordEasyLoanCApprovedOTP = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    'clickTextBox',
    'OTP'
);

export const recordEasyLoanCApprovedNewCode = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_LINK_EVENT,
    'requestNewCode'
);

export const recordEasyLoanCApprovedWizardError = () => recordLinkV2({
    event_name: "event_success",
    action: "success",
    format: "steps",
    component: "funnel",
    element: "confirmation"
});

export const recordEasyLoanCApprovedCancelRecord = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    "modal cancelar solicitud",
    "cancelar"
);

export const recordEasyLoanCApprovedSignatureKey = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_TEXT_BOX_EVENT,
    "signatureKey"
);

export const recordEasyLoanCApprovedDocumentSignature = (event) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_RADIO_BUTTON_EVENT,
    `documento firmado ${event}`
);
